export const DEFAULT_DISTANCE = "25";
export const DEFAULT_ZOOM = 9;
export const DEFAULT_LIST_SIZE_PER_PAGE = 5;
